import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CopyState } from './types'

export const initialState: CopyState = {
  json: undefined
}

export const { reducer, actions } = createSlice({
  name: 'copy',
  initialState,
  reducers: {
    copy: (state, action: PayloadAction<string>) => {
      state.json = action.payload
    }
  }
})
